import { Injectable } from '@angular/core';
import * as firebase from 'firebase'

@Injectable({
  providedIn: 'root'
})
export class LocacionesService {

  constructor() { }

  pozos=  [
   {
      id: 1,
      name: "Toroyaco-1",
      regional: "Putumayo norte"
    },
    {
      id: 2,
      name: "Toroyaco-2",
      regional: "Putumayo norte"
    },
    {
      id: 3,
      name: "Toroyaco-3",
      regional: "Putumayo norte"
    },
    {
      id: 4,
      name: "Toroyaco-4",
      regional: "Putumayo norte"
    },
    {
      id: 5,
      name: "Mary-1",
      regional: "Putumayo norte"
    },
    {
      id: 6,
      name: "Mary-2",
      regional: "Putumayo norte"
    },
    {
      id: 7,
      name: "Mary-3",
      regional: "Putumayo norte"
    },
    {
      id: 8,
      name: "Mary-5",
      regional: "Putumayo norte"
    },
    {
      id: 9,
      name: "Linda",
      regional: "Putumayo norte"
    },
    {
      id: 10,
      name: "Miraflor Oeste-1",
      regional: "Putumayo norte"
    },
    {
      id: 11,
      name: "Miraflor-1",
      regional: "Putumayo norte"
    },
    {
      id: 12,
      name: "Costayaco-1",
      regional: "Putumayo norte"
    },
    {
      id: 13,
      name: "Costayaco-2",
      regional: "Putumayo norte"
    },
    {
      id: 14,
      name: "Costayaco-3",
      regional: "Putumayo norte"
    },
    {
      id: 15,
      name: "Costayaco-4",
      regional: "Putumayo norte"
    },
    {
      id: 16,
      name: "Costayaco-5",
      regional: "Putumayo norte"
    },
    {
      id: 17,
      name: "Costayaco-7",
      regional: "Putumayo norte"
    },
    {
      id: 18,
      name: "Costayaco-8",
      regional: "Putumayo norte"
    },
    {
      id: 19,
      name: "Costayaco-9",
      regional: "Putumayo norte"
    },
    {
      id: 20,
      name: "Costayaco-11",
      regional: "Putumayo norte"
    },
    {
      id: 21,
      name: "Costayaco-16D",
      regional: "Putumayo norte"
    },
    {
      id: 22,
      name: "Costayaco-18D",
      regional: "Putumayo norte"
    },
    {
      id: 23,
      name: "Costayaco-19D ST3",
      regional: "Putumayo norte"
    },
    {
      id: 24,
      name: "Costayaco-20",
      regional: "Putumayo norte"
    },
    {
      id: 25,
      name: "Costayaco-21",
      regional: "Putumayo norte"
    },
    {
      id: 26,
      name: "Costayaco-22",
      regional: "Putumayo norte"
    },
    {
      id: 27,
      name: "Costayaco-24",
      regional: "Putumayo norte"
    },
    {
      id: 28,
      name: "Costayaco-25",
      regional: "Putumayo norte"
    },
    {
      id: 29,
      name: "Costayaco-26D",
      regional: "Putumayo norte"
    },
    {
      id: 30,
      name: "Costayaco-28",
      regional: "Putumayo norte"
    },
    {
      id: 31,
      name: "Costayaco-29H",
      regional: "Putumayo norte"
    },
    {
      id: 32,
      name: "Costayaco-30",
      regional: "Putumayo norte"
    },
    {
      id: 33,
      name: "Costayaco-31",
      regional: "Putumayo norte"
    },
    {
      id: 34,
      name: "Costayaco-32",
      regional: "Putumayo norte"
    },
    {
      id: 35,
      name: "Costayaco-33",
      regional: "Putumayo norte"
    },
    {
      id: 36,
      name: "Costayaco-35",
      regional: "Putumayo norte"
    },
    {
      id: 37,
      name: "Costayaco-36",
      regional: "Putumayo norte"
    },
    {
      id: 38,
      name: "Costayaco-39",
      regional: "Putumayo norte"
    },
    {
      id: 39,
      name: "Costayaco-40",
      regional: "Putumayo norte"
    },
    {
      id: 40,
      name: "Costayaco-42",
      regional: "Putumayo norte"
    },
    {
      id: 41,
      name: "Cocona-2",
      regional: "Putumayo norte"
    },
    {
      id: 42,
      name: "Vonu-1",
      regional: "Putumayo norte"
    },
    {
      id: 43,
      name: "Moqueta-1",
      regional: "Putumayo norte"
    },
    {
      id: 44,
      name: "Moqueta-2",
      regional: "Putumayo norte"
    },
    {
      id: 45,
      name: "Moqueta-3",
      regional: "Putumayo norte"
    },
    {
      id: 46,
      name: "Moqueta-4",
      regional: "Putumayo norte"
    },
    {
      id: 47,
      name: "Moqueta-5",
      regional: "Putumayo norte"
    },
    {
      id: 48,
      name: "Moqueta-6",
      regional: "Putumayo norte"
    },
    {
      id: 49,
      name: "Moqueta-8",
      regional: "Putumayo norte"
    },
    {
      id: 50,
      name: "Moqueta-9",
      regional: "Putumayo norte"
    },
    {
      id: 51,
      name: "Moqueta-11",
      regional: "Putumayo norte"
    },
    {
      id: 52,
      name: "Moqueta-12",
      regional: "Putumayo norte"
    },
    {
      id: 53,
      name: "Moqueta-15",
      regional: "Putumayo norte"
    },
    {
      id: 54,
      name: "Moqueta-16",
      regional: "Putumayo norte"
    },
    {
      id: 55,
      name: "Moqueta-17",
      regional: "Putumayo norte"
    },
    {
      id: 56,
      name: "Moqueta-18",
      regional: "Putumayo norte"
    },
    {
      id: 57,
      name: "Moqueta-20",
      regional: "Putumayo norte"
    },
    {
      id: 58,
      name: "Moqueta-21",
      regional: "Putumayo norte"
    },
    {
      id: 59,
      name: "Moqueta-22",
      regional: "Putumayo norte"
    },
    {
      id: 60,
      name: "Moqueta-23",
      regional: "Putumayo norte"
    },
    {
      id: 61,
      name: "Guayuyaco-1",
      regional: "Putumayo norte"
    },
    {
      id: 62,
      name: "Guayuyaco-2",
      regional: "Putumayo norte"
    },
    {
      id: 63,
      name: "Juanambu-1",
      regional: "Putumayo norte"
    },
    {
      id: 64,
      name: "Juanambu-2",
      regional: "Putumayo norte"
    },
    {
      id: 65,
      name: "Juanambu-3",
      regional: "Putumayo norte"
    },
    {
      id: 66,
      name: "Portería Principal",
      regional: "Putumayo norte"
    },
    {
      id: 67,
      name: "Santana",
      regional: "Putumayo norte"
    },
    {
      id: 68,
      name: "Campamento",
      regional: "Putumayo norte"
    },
    {
      id: 69,
      name: "Oficinas",
      regional: "Putumayo norte"
    },
    {
      id: 70,
      name: "CPF - Put Norte",
      regional: "Putumayo norte"
    },
    {
      id: 71,
      name: "Bodegas",
      regional: "Putumayo norte"
    },
    {
      id: 72,
      name: "Gas to Power",
      regional: "Putumayo norte"
    },
    {
      id: 73,
      name: "Caseta Contingencia",
      regional: "Putumayo norte"
    },
    {
      id: 74,
      name: "Pórtico",
      regional: "Putumayo norte"
    },
    {
      id: 75,
      name: "SantaLucía-1",
      regional: "VMM-otros"
    },
    {
      id: 76,
      name: "SantaLucía-2",
      regional: "VMM-otros"
    },
    {
      id: 77,
      name: "SantaLucía-3",
      regional: "VMM-otros"
    },
    {
      id: 78,
      name: "SantaLucía-4 ST",
      regional: "VMM-otros"
    },
    {
      id: 79,
      name: "SantaLucía-5",
      regional: "VMM-otros"
    },
    {
      id: 80,
      name: "LosAngeles-3",
      regional: "VMM-otros"
    },
    {
      id: 81,
      name: "LosAngeles-4",
      regional: "VMM-otros"
    },
    {
      id: 82,
      name: "LosAngeles-5",
      regional: "VMM-otros"
    },
    {
      id: 83,
      name: "LosAngeles-6",
      regional: "VMM-otros"
    },
    {
      id: 84,
      name: "LosAngeles-7",
      regional: "VMM-otros"
    },
    {
      id: 85,
      name: "LosAngeles-8",
      regional: "VMM-otros"
    },
    {
      id: 86,
      name: "LosAngeles-9",
      regional: "VMM-otros"
    },
    {
      id: 87,
      name: "LosAngeles-10",
      regional: "VMM-otros"
    },
    {
      id: 88,
      name: "LosAngeles-11",
      regional: "VMM-otros"
    },
    {
      id: 89,
      name: "LosAngeles-12",
      regional: "VMM-otros"
    },
    {
      id: 90,
      name: "LosAngeles-13 ST",
      regional: "VMM-otros"
    },
    {
      id: 91,
      name: "LosAngeles-14",
      regional: "VMM-otros"
    },
    {
      id: 92,
      name: "LosAngeles-15",
      regional: "VMM-otros"
    },
    {
      id: 93,
      name: "LosAngeles-16",
      regional: "VMM-otros"
    },
    {
      id: 94,
      name: "LosAngeles-17",
      regional: "VMM-otros"
    },
    {
      id: 95,
      name: "LosAngeles-18",
      regional: "VMM-otros"
    },
    {
      id: 96,
      name: "LosAngeles-20",
      regional: "VMM-otros"
    },
    {
      id: 97,
      name: "Querubín-1",
      regional: "VMM-otros"
    },
    {
      id: 98,
      name: "Querubín-2",
      regional: "VMM-otros"
    },
    {
      id: 99,
      name: "Tronos",
      regional: "VMM-otros"
    },
    {
      id: 100,
      name: "Serafin 1",
      regional: "VMM-otros"
    },
    {
      id: 101,
      name: "Colón-1 ST",
      regional: "VMM-otros"
    },
    {
      id: 102,
      name: "Colón-2",
      regional: "VMM-otros"
    },
    {
      id: 103,
      name: "Colón-3 ST",
      regional: "VMM-otros"
    },
    {
      id: 104,
      name: "Colón-4",
      regional: "VMM-otros"
    },
    {
      id: 105,
      name: "Colón-5",
      regional: "VMM-otros"
    },
    {
      id: 106,
      name: "Ayombero-1",
      regional: "VMM-otros"
    },
    {
      id: 107,
      name: "Ayombero-2",
      regional: "VMM-otros"
    },
    {
      id: 108,
      name: "Ayombero-3",
      regional: "VMM-otros"
    },
    {
      id: 109,
      name: "Chuira-1 ST",
      regional: "VMM-otros"
    },
    {
      id: 110,
      name: "Chuira-2 ST",
      regional: "VMM-otros"
    },
    {
      id: 111,
      name: "Tonga1",
      regional: "VMM-otros"
    },
    {
      id: 112,
      name: "MonoAraña-1",
      regional: "VMM-otros"
    },
    {
      id: 113,
      name: "MonoAraña-1 ST",
      regional: "VMM-otros"
    },
    {
      id: 114,
      name: "MonoAraña-2",
      regional: "VMM-otros"
    },
    {
      id: 115,
      name: "MonoAraña-5",
      regional: "VMM-otros"
    },
    {
      id: 116,
      name: "MonoAraña-9",
      regional: "VMM-otros"
    },
    {
      id: 117,
      name: "MonoAraña-11",
      regional: "VMM-otros"
    },
    {
      id: 118,
      name: "Juglar-1",
      regional: "VMM-otros"
    },
    {
      id: 119,
      name: "Juglar-2 ST",
      regional: "VMM-otros"
    },
    {
      id: 120,
      name: "Acordionero-1",
      regional: "VMM"
    },
    {
      id: 121,
      name: "Acordionero-2",
      regional: "VMM"
    },
    {
      id: 122,
      name: "Acordionero-3",
      regional: "VMM"
    },
    {
      id: 123,
      name: "Acordionero-4",
      regional: "VMM"
    },
    {
      id: 124,
      name: "Acordionero-5",
      regional: "VMM"
    },
    {
      id: 125,
      name: "Acordionero-6",
      regional: "VMM"
    },
    {
      id: 126,
      name: "Acordionero-7",
      regional: "VMM"
    },
    {
      id: 127,
      name: "Acordionero-9",
      regional: "VMM"
    },
    {
      id: 128,
      name: "Acordionero-10",
      regional: "VMM"
    },
    {
      id: 129,
      name: "Acordionero-11",
      regional: "VMM"
    },
    {
      id: 130,
      name: "Acordionero-12",
      regional: "VMM"
    },
    {
      id: 131,
      name: "Acordionero-13",
      regional: "VMM"
    },
    {
      id: 132,
      name: "Acordionero-15",
      regional: "VMM"
    },
    {
      id: 133,
      name: "Acordionero-16",
      regional: "VMM"
    },
    {
      id: 134,
      name: "Acordionero-17",
      regional: "VMM"
    },
    {
      id: 135,
      name: "Acordionero-18",
      regional: "VMM"
    },
    {
      id: 136,
      name: "Acordionero-20 ST",
      regional: "VMM"
    },
    {
      id: 137,
      name: "Acordionero-21 ST",
      regional: "VMM"
    },
    {
      id: 138,
      name: "Acordionero-22",
      regional: "VMM"
    },
    {
      id: 139,
      name: "Acordionero-24",
      regional: "VMM"
    },
    {
      id: 140,
      name: "Acordionero-25",
      regional: "VMM"
    },
    {
      id: 141,
      name: "Acordionero-26",
      regional: "VMM"
    },
    {
      id: 142,
      name: "Acordionero-27",
      regional: "VMM"
    },
    {
      id: 143,
      name: "Acordionero-28",
      regional: "VMM"
    },
    {
      id: 144,
      name: "Acordionero-29",
      regional: "VMM"
    },
    {
      id: 145,
      name: "Acordionero-30",
      regional: "VMM"
    },
    {
      id: 146,
      name: "Acordionero-32",
      regional: "VMM"
    },
    {
      id: 147,
      name: "Acordionero-33 ST1",
      regional: "VMM"
    },
    {
      id: 148,
      name: "Acordionero-34",
      regional: "VMM"
    },
    {
      id: 149,
      name: "Acordionero-35",
      regional: "VMM"
    },
    {
      id: 150,
      name: "Acordionero-36",
      regional: "VMM"
    },
    {
      id: 151,
      name: "Acordionero-37",
      regional: "VMM"
    },
    {
      id: 152,
      name: "Acordionero-37 Mochuelo-1 ST Totumillo-1",
      regional: "VMM"
    },
    {
      id: 153,
      name: "Acordionero-38",
      regional: "VMM"
    },
    {
      id: 154,
      name: "Acordionero-39",
      regional: "VMM"
    },
    {
      id: 155,
      name: "Acordionero-40",
      regional: "VMM"
    },
    {
      id: 156,
      name: "Acordionero-41",
      regional: "VMM"
    },
    {
      id: 157,
      name: "Acordionero-42",
      regional: "VMM"
    },
    {
      id: 158,
      name: "Acordionero-43",
      regional: "VMM"
    },
    {
      id: 159,
      name: "Acordionero-44",
      regional: "VMM"
    },
    {
      id: 160,
      name: "Acordionero-45",
      regional: "VMM"
    },
    {
      id: 161,
      name: "Acordionero-46",
      regional: "VMM"
    },
    {
      id: 162,
      name: "Acordionero-47",
      regional: "VMM"
    },
    {
      id: 163,
      name: "Acordionero-48",
      regional: "VMM"
    },
    {
      id: 164,
      name: "Acordionero-49",
      regional: "VMM"
    },
    {
      id: 165,
      name: "Acordionero-50",
      regional: "VMM"
    },
    {
      id: 166,
      name: "Acordionero-51",
      regional: "VMM"
    },
    {
      id: 167,
      name: "Acordionero-52",
      regional: "VMM"
    },
    {
      id: 168,
      name: "Acordionero-53",
      regional: "VMM"
    },
    {
      id: 169,
      name: "Acordionero-54",
      regional: "VMM"
    },
    {
      id: 170,
      name: "Acordionero-55",
      regional: "VMM"
    },
    {
      id: 171,
      name: "Acordionero-56",
      regional: "VMM"
    },
    {
      id: 172,
      name: "Acordionero-57",
      regional: "VMM"
    },
    {
      id: 173,
      name: "Acordionero-58",
      regional: "VMM"
    },
    {
      id: 173.1,
      name: "Acordionero-70",
      regional: "VMM"
    },
    {
      id: 173.2,
      name: "Acordionero-71",
      regional: "VMM"
    },
    {
      id: 173.3,
      name: "Acordionero-72",
      regional: "VMM"
    },
    {
      id: 173.4,
      name: "Acordionero-73",
      regional: "VMM"
    },
    {
      id: 173.5,
      name: "Acordionero-74",
      regional: "VMM"
    },
    {
      id: 173.5,
      name: "Acordionero-75",
      regional: "VMM"
    },
    {
      id: 174,
      name: "Campamento",
      regional: "VMM"
    },
    {
      id: 175,
      name: "CPF",
      regional: "VMM"
    },
    {
      id: 176,
      name: "Pad Central",
      regional: "VMM"
    },
    {
      id: 177,
      name: "Cargadero",
      regional: "VMM"
    },
    {
      id: 178,
      name: "Sede San Alberto",
      regional: "VMM"
    },
    {
      id: 179,
      name: "Portillo",
      regional: "VMM"
    },
    {
      id: 180,
      name: "Pad Sur",
      regional: "VMM"
    },
    {
      id: 181,
      name: "Pad 2",
      regional: "VMM"
    },
    {
      id: 182,
      name: "Pad 4",
      regional: "VMM"
    },
    {
      id: 183,
      name: "Pad 6",
      regional: "VMM"
    },
    {
      id: 184,
      name: "CPF Plataforma de pozos.",
      regional: "VMM"
    },
    {
      id: 184.1,
      name: "Perifericos",
      regional: "VMM"
    },
    {
      id: 184.2,
      name: "Southwest",
      regional: "VMM"
    },
    {
      id: 185,
      name: "Siriri",
      regional: "Putumayo sur"
    },
    {
      id: 186,
      name: "Carana",
      regional: "Putumayo sur"
    },
    {
      id: 187,
      name: "Cumplidor-1",
      regional: "Putumayo sur"
    },
    {
      id: 188,
      name: "Cumplidor-2",
      regional: "Putumayo sur"
    },
    {
      id: 189,
      name: "Confianza",
      regional: "Putumayo sur"
    },
    {
      id: 190,
      name: "Alpha",
      regional: "Putumayo sur"
    },
    {
      id: 191,
      name: "Pomorroso",
      regional: "Putumayo sur"
    },
    {
      id: 192,
      name: "Almendrillo",
      regional: "Putumayo sur"
    },
    {
      id: 193,
      name: "Pecari",
      regional: "Putumayo sur"
    },
    {
      id: 194,
      name: "Chilanguita",
      regional: "Putumayo sur"
    },
    {
      id: 195,
      name: "Quinde 4-6",
      regional: "Putumayo sur"
    },
    {
      id: 196,
      name: "Quinde-2",
      regional: "Putumayo sur"
    },
    {
      id: 197,
      name: "Quinde-3",
      regional: "Putumayo sur"
    },
    {
      id: 198,
      name: "Quinde-4",
      regional: "Putumayo sur"
    },
    {
      id: 199,
      name: "Quinde-6",
      regional: "Putumayo sur"
    },
    {
      id: 200,
      name: "Quinde-7",
      regional: "Putumayo sur"
    },
    {
      id: 201,
      name: "Cohembí-3",
      regional: "Putumayo sur"
    },
    {
      id: 202,
      name: "Cohembí-4",
      regional: "Putumayo sur"
    },
    {
      id: 203,
      name: "Cohembí-5",
      regional: "Putumayo sur"
    },
    {
      id: 204,
      name: "Cohembí-7",
      regional: "Putumayo sur"
    },
    {
      id: 205,
      name: "Cohembí-9",
      regional: "Putumayo sur"
    },
    {
      id: 206,
      name: "Cohembí-10",
      regional: "Putumayo sur"
    },
    {
      id: 207,
      name: "Cohembí-11",
      regional: "Putumayo sur"
    },
    {
      id: 208,
      name: "Cohembí-12",
      regional: "Putumayo sur"
    },
    {
      id: 209,
      name: "Cohembí-13",
      regional: "Putumayo sur"
    },
    {
      id: 210,
      name: "Cohembí-14",
      regional: "Putumayo sur"
    },
    {
      id: 211,
      name: "Cohembí-15",
      regional: "Putumayo sur"
    },
    {
      id: 212,
      name: "Cohembí-16",
      regional: "Putumayo sur"
    },
    {
      id: 213,
      name: "Cohembí-20",
      regional: "Putumayo sur"
    },
    {
      id: 214,
      name: "Cohembí-21",
      regional: "Putumayo sur"
    },
    {
      id: 215,
      name: "Cohembí-22",
      regional: "Putumayo sur"
    },
    {
      id: 216,
      name: "Piñuña-1",
      regional: "Putumayo sur"
    },
    {
      id: 217,
      name: "Piñuña-2",
      regional: "Putumayo sur"
    },
    {
      id: 218,
      name: "Piñuña-3",
      regional: "Putumayo sur"
    },
    {
      id: 219,
      name: "Piñuña-4",
      regional: "Putumayo sur"
    },
    {
      id: 220,
      name: "Piñuña-5",
      regional: "Putumayo sur"
    },
    {
      id: 221,
      name: "Piñuña-6",
      regional: "Putumayo sur"
    },
    {
      id: 222,
      name: "Piñuña-7",
      regional: "Putumayo sur"
    },
    {
      id: 223,
      name: "Curiquinga",
      regional: "Putumayo sur"
    },
    {
      id: 224,
      name: "Estación Nancy",
      regional: "Putumayo sur"
    },
    {
      id: 225,
      name: "Estación Cumplidor",
      regional: "Putumayo sur"
    },
    {
      id: 225,
      name: "Estación Quillacinga",
      regional: "Putumayo sur"
    },
    {
      id: 225,
      name: "Estación Cohembi",
      regional: "Putumayo sur"
    },
    {
      id: 226,
      name: "Estación Quinde",
      regional: "Putumayo sur"
    },
    {
      id: 227,
      name: "PAD 2",
      regional: "Putumayo sur"
    },
    {
      id: 228,
      name: "PAD 3",
      regional: "Putumayo sur"
    },
    {
      id: 229,
      name: "PAD 4",
      regional: "Putumayo sur"
    },
    {
      id: 230,
      name: "PAD 5",
      regional: "Putumayo sur"
    },
    {
      id: 231,
      name: "PAD 6",
      regional: "Putumayo sur"
    },
    {
      id: 232,
      name: "Curiquinga",
      regional: "Putumayo sur"
    },
    {
      id: 233,
      name: "Piñuña 3-5",
      regional: "Putumayo sur"
    },
    {
      id: 234,
      name: "Piñuña 1-2",
      regional: "Putumayo sur"
    },
    {
      id: 235,
      name: "Piñuña 4-6",
      regional: "Putumayo sur"
    },
    {
      id: 236,
      name: "Burdine 1",
      regional: "Putumayo sur"
    },
    {
      id: 237,
      name: "Burdine 2",
      regional: "Putumayo sur"
    },
    {
      id: 238,
      name: "Burdine 3",
      regional: "Putumayo sur"
    },
    {
      id: 239,
      name: "Burdine 4",
      regional: "Putumayo sur"
    },
    {
      id: 240,
      name: "Burdine 5",
      regional: "Putumayo sur"
    },
    {
      id: 241,
      name: "Bogotá",
      regional: "Bogota"
    }
  ]

  

  


  






    
}//fin de clase


 			
			
		
			
			
		
			